import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
import React from 'react';
import { Menu } from 'semantic-ui-react';
import { DEFAULT_LINK_AS } from './Link.constants';
import BaseLink from '../../../../../../atoms/Link';
import { isExternalPage } from '../../../../../../services/pages';
import { ObjectPropsPropType } from '../../../../../../services/proptypes';
import { EVENT_CATEGORIES, EVENT_ACTIONS } from '../../../../../analytics/components/Event';
var defaultProps = {
  type: 'internal',
  url: '',
  slug: '',
  as: DEFAULT_LINK_AS,
  title: '',
  className: '',
  linkProps: {},
  menuItemProps: {},
  onClick: function onClick() {
    return null;
  }
};
export default function Link(_ref) {
  var type = _ref.type,
    url = _ref.url,
    slug = _ref.slug,
    as = _ref.as,
    title = _ref.title,
    className = _ref.className,
    linkProps = _ref.linkProps,
    onClick = _ref.onClick,
    menuItemProps = _ref.menuItemProps;
  var isExternal = isExternalPage(type);
  var baseLinkProps = _objectSpread({
    to: isExternal ? url : slug,
    linkAs: as,
    title: title,
    internal: !isExternal,
    className: className
  }, linkProps);
  return /*#__PURE__*/React.createElement(Menu.Item, _extends({
    link: true
  }, menuItemProps, {
    onClick: onClick,
    as: BaseLink
  }, baseLinkProps, {
    event: {
      category: EVENT_CATEGORIES.NAVIGATION_EVENT_CATEGORY,
      action: EVENT_ACTIONS.NAVIGATION_MENU_CLICK_EVENT_ACTION,
      label: title
    }
  }));
}
Link.defaultProps = defaultProps;